<!-- 供货商操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <!-- 主信息 -->
                            <div v-if="scope.index == 0">
                                <el-form label-width="140px" label-position="right" size="mini" ref="dynamicValidateForm" class="baseForm" :model="sendDataInfoObj" :show-message="false">
                                    <el-row>
                                        <el-form-item label="申请部门" prop="cmCode">
                                            <label slot="label" :style="$common.labelStyle('申请部门')" v-html="$common.htmlLabel('申请部门')"></label>
                                            <el-input disabled v-model="sendDataInfoObj.depName"></el-input>
                                        </el-form-item>
                                        <el-form-item label="申请人" prop="cmCode">
                                            <label slot="label" :style="$common.labelStyle('申请人')" v-html="$common.htmlLabel('申请人')"></label>
                                            <el-input clearable disabled v-model="sendDataInfoObj.opmName"></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row>
                                        <el-form-item label="申请原因" prop="applyReason" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('申请原因')" v-html="$common.htmlLabel('申请原因')"></label>
                                            <el-input clearable type="textarea" :rows="2" v-model="sendDataInfoObj.applyReason"></el-input>
                                        </el-form-item>
                                        <el-form-item label="修改备注" prop="remark">
                                            <label slot="label" :style="$common.labelStyle('修改备注')" v-html="$common.htmlLabel('修改备注')"></label>
                                            <el-input clearable type="textarea" rows="2" v-model="sendDataInfoObj.remark"></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-form-item v-if="dataActionBox.actionType == 0 || dataActionBox.actionType == 3">
                                        <el-button type="primary" @click="openSearch(3386264207560704, 0, 'smName', 'smName,smId')">提取供应商</el-button>
                                    </el-form-item>
                                </el-form>
                                <el-divider content-position="left">
                                    <h4>供应商信息</h4>
                                </el-divider>
                                <el-form label-width="150px" label-position="right" size="mini" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" :show-message="false">
                                    <el-row>
                                        <el-form-item v-if="formOneValue.isShow == 1" :label="formOneValue.showField" :prop="formOneValue.entityField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                      :key="formOneKey" :id="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                            <el-tooltip class="item"
                                                        :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' || sendDataInfo[formOneValue.entityField].length <= 9 ? true : false"
                                                        effect="dark" :content="getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)"
                                                        placement="bottom-start">
                                                <!-- 单位类型 -->
                                                <el-select filterable v-if="formOneValue.entityField == 'smIntype'" v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;"
                                                           :disabled="formOneValue.isUpdate == 0" clearable @change="changesmIntype">
                                                    <el-option v-for="(values) in dictionariesDatas" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                                </el-select>
                                                <el-input v-if="formOneValue.entityField == 'smName'" clearable v-model="sendDataInfo['smName']" :disabled="formOneValue.isUpdate == 0"></el-input>
                                                <el-cascader ref="cascader" :props="{ emitPath: false }" v-else-if="formOneValue.entityField == 'areaCode'" style="width: 100%;" :options="options"
                                                             v-model="sendDataInfo[formOneValue.entityField]" @change="handleAddChange" clearable filterable>
                                                </el-cascader>
                                                <el-select :disabled="formOneValue.isUpdate == 0" filterable size="mini" v-else-if="formOneValue.fieldType == 'formatter'"
                                                           @change="((val) => { handleChange(val, formOneValue.entityField) })" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value"></el-option>
                                                </el-select>
                                                <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                          :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                          :disabled="formOneValue.isUpdate == 0">
                                                    <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                               :disabled="formOneValue.isUpdate == 0">
                                                    </el-button>
                                                </el-input>
                                                <el-input v-else-if="formOneValue.entityField == 'smHemcode'" :disabled="formOneValue.isUpdate == 0" v-model="sendDataInfo[formOneValue.entityField]" maxlength="64"
                                                          show-word-limit clearable></el-input>
                                                <!-- 营业期限 -->
                                                <df-date :isdisabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <!-- 注册地址 -->
                                                <el-input :disabled="formOneValue.isUpdate == 0"
                                                          v-else-if="formOneValue.entityField == 'smRegaddres' || formOneValue.entityField == 'smWareaddress' || formOneValue.entityField == 'smBank' || formOneValue.entityField == 'smRemark' || formOneValue.entityField == 'smPlace'"
                                                          v-model="sendDataInfo[formOneValue.entityField]" type="textarea" maxlength="500"></el-input>
                                                <!-- 信贷期 -->
                                                <el-input v-else-if="formOneValue.entityField == 'sfiCreditperiod'" v-model="sendDataInfo[formOneValue.entityField]" type="number" :disabled="formOneValue.isUpdate == 0"
                                                          clearable>
                                                    <template slot="append">天</template>
                                                </el-input>
                                                <!-- 信贷额 -->
                                                <el-input v-else-if="formOneValue.entityField == 'sfiCreditamount'" v-model="sendDataInfo[formOneValue.entityField]" type="number" :disabled="formOneValue.isUpdate == 0"
                                                          clearable>
                                                    <template slot="append">元</template>
                                                </el-input>
                                                <el-input v-else-if="formOneValue.entityField == 'smSocialcode'" @blur="blurChange(formOneValue.entityField)" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                          :disabled="formOneValue.isUpdate == 0" clearable>
                                                    <template slot="append"><span style="color: red;">{{ sendDataInfo[formOneValue.entityField] == '' ||
                                                sendDataInfo[formOneValue.entityField] == null ||
                                                sendDataInfo[formOneValue.entityField] == undefined ? 0 :
                                             sendDataInfo[formOneValue.entityField].length }}位</span></template>
                                                </el-input>
                                                <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :disabled="formOneValue.isUpdate == 0" clearable>
                                                </el-input>
                                            </el-tooltip>
                                        </el-form-item>

                                    </el-row>
                                </el-form>
                                <el-form :model="obj" ref="sendDataInfo1" :show-message="false">
                                    <el-form-item v-for="(formOneValue, formOneKey) in dataList" :key="formOneKey" :prop="formOneValue.entityField == 'smProrange' ? 'smProrangeValues' : 'smManrangeValues'"
                                                  :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                        <div id="smProrange" v-if="formOneValue.entityField == 'smProrange'">
                                            <div class="cmTitle"><span style="color: red;padding-right: 5px;" v-if="formOneValue.isRequired == 1">*</span>{{
                                    formOneValue.showField }}
                                            </div>
                                            <div class="cmContent">
                                                <el-button class="cmButton" @click="openRange('生产范围', 'smProrange')" type="info" plain size="mini">选择生产范围</el-button>
                                                <el-input type="textarea" v-model="obj.smProrangeValues" readonly>
                                                </el-input>
                                            </div>
                                        </div>
                                        <div id="smManrange" v-else-if="formOneValue.entityField == 'smManrange'">
                                            <div class="cmTitle"><span style="color: red;padding-right: 5px;" v-if="formOneValue.isRequired == 1">*</span>{{
                                    formOneValue.showField }}
                                            </div>
                                            <div class="cmContent">
                                                <el-button class="cmButton" @click="openRange('经营范围', 'smManrange')" type="info" plain size="mini">选择经营范围</el-button>
                                                <el-input type="textarea" v-model="obj.smManrangeValues" readonly>
                                                </el-input>
                                            </div>
                                        </div>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <!-- 证照信息 -->
                            <div v-if="scope.index == 1">
                                <div id="operateBtn">
                                    <el-checkbox-group v-model="zzList" style="display: flex;align-items: center;flex-wrap: wrap;">
                                        <div v-for="(item, index) in LicensetypeList" :key="index" style="width: 250px;padding-left: 15px;position: relative;">
                                            <span v-if="item.isBT == 1" style="color:red;" class="xing">*</span>
                                            <span v-if="item.isKX == 1" style="color:#409EFF;" class="xing">*</span>
                                            <el-checkbox style="width: 220px;" :label="item.diName"></el-checkbox>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                                <el-table v-if="scope.row" :data="sendDataInfo.newLicencelinfos" border style="width: 100%" size="mini" :height="mxHeight">
                                    <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in scope.row.jurconfigform" :key="tableKey" :prop="tableValye.entityField"
                                                     :label="tableValye.showField" :show-overflow-tooltip="tableValye.entityField == 'uploadVoList' ? false : true" :min-width="dealMinWidth(tableValye.entityField)"
                                                     :fixed="tableValye.entityField == 'uploadVoList' ? 'right' : false">
                                        <template slot-scope="scope">
                                            <div>
                                                <!-- 系统字段 -->
                                                <div v-if="tableValye.isReserved == 0">
                                                    <df-date :isType="true" :isShowLong="false" :isdisabled="tableValye.isUpdate == 0" v-if="tableValye.entityField == 'sliRedate'"
                                                             v-model="sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]" />
                                                    <df-date :isType="true" :isdisabled="tableValye.isUpdate == 0" v-else-if="tableValye.entityField == 'sliTervalidity'"
                                                             v-model="sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]" @change="changesliTervalidity(scope.$index)"></df-date>
                                                    <df-date :isType="true" :isdisabled="tableValye.isUpdate == 0" v-else-if="tableValye.fieldType == 'date'"
                                                             v-model="sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]"></df-date>
                                                    <ul v-else-if="tableValye.entityField == 'uploadVoList'" class="uploadList">
                                                        <li v-for="(val, key) in scope.row.uploadVoList" :key="key" class="image">
                                                            <i class="el-icon-error del" @click="delRemove(scope.$index, key)"></i>
                                                            <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="val.url" :preview-src-list="scope.row.uploadVoList.map(item=>item.url)">
                                                            </cusImage>
                                                        </li>
                                                    </ul>
                                                    <!-- 证照类型 -->
                                                    <span v-else-if="tableValye.entityField == 'lityId'">{{ sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField] }}</span><!-- 是否拦截 -->
                                                    <el-radio-group v-else-if="tableValye.entityField == 'isIntercept'" :disabled="tableValye.isUpdate == 0"
                                                                    v-model="sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                    <el-select filterable size="mini" v-else-if="tableValye.fieldType == 'formatter'" v-model="sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]"
                                                               placeholder="请选择">
                                                        <el-option v-for="matItem in JSON.parse(tableValye.formatterContent)" :key="matItem.value" :label="matItem.value" :value="matItem.value"></el-option>
                                                    </el-select>

                                                    <!-- 备注 -->
                                                    <el-input v-else-if="tableValye.entityField == 'remark'" type="textarea" ref="remark" v-model.trim="sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]"
                                                              maxlength="200"></el-input>
                                                    <el-input v-else-if="tableValye.entityField == 'sliTernumber'" v-model.trim="sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]"
                                                              :maxlength="$store.state.inputLength" clearable>
                                                        <template slot="append"><span style="color: red;">{{ sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField] ==
                                                   '' || sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]
                                                   == null
                                                   || sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]==
                                                undefined ? 0
                                                :sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField].length}}位</span></template>
                                                    </el-input>
                                                    <el-input v-else v-model.trim="sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]" :maxlength="$store.state.inputLength" clearable></el-input>
                                                </div>
                                                <!-- 扩展字段 -->
                                                <div v-if="tableValye.isReserved == 1">
                                                    <!-- 自填 -->
                                                    <el-input v-model.trim="sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]" v-if="tableValye.operatType == 0" :maxlength="$store.state.inputLength"
                                                              :disabled="tableValye.isUpdate == 0" clearable></el-input>
                                                    <!-- 选择数据来源 -->
                                                    <el-input v-model.trim="sendDataInfo.newLicencelinfos[scope.$index][tableValye.entityField]" v-else :maxlength="$store.state.inputLength"
                                                              :disabled="tableValye.isUpdate == 0" clearable></el-input>
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column fixed="right" label="操作" :width="printScanShow?380:300">
                                        <template slot-scope="scope">
                                            <input style="display: none;" type="file" id="recordExcel" accept="image/*" multiple name="recordExcel"
                                                   @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e) }" />
                                            <label for="recordExcel" class="image_label" @click="eventIndex = scope.$index">上传</label>
                                            <el-button type="primary" @click="showUploadDialog(scope.$index)">拖拽上传</el-button>
                                            <el-button @click.stop="openFile1(0), (eventIndex = scope.$index)" type="primary" size="mini">高拍仪</el-button>
                                            <el-button v-if="printScanShow" @click.stop="openFile1(1), (eventIndex = scope.$index)" type="primary" size="mini">扫描仪</el-button>
                                            <el-button type="primary" size="mini" @click="copyClick(scope.row)">复制</el-button>
                                            <el-button @click="delCertofocates(scope.row)" type="danger" size="mini">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <el-button type="primary" @click="initActionBox">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0 || dataActionBox.actionType == 3">保存
                    </el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存
                    </el-button>
                </div>
            </div>
            <!-- 范围穿梭框 -->
            <el-dialog :title="'选择' + rangeTitle" :visible.sync="dialogRange" width="70%" :modal-append-to-body='true' id=csDia :append-to-body="true" :before-close="handleClose">
                <div class="edit_dev">
                    <el-transfer filterable v-if="dialogRange" :filter-method="filterMethod" target-order="push" filter-placeholder="请输入范围名称" v-model="rangeValue" :titles="['未选择', '已选择']" :data="transferData">
                    </el-transfer>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="confirmRange">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
                <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            </el-dialog>
            <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true" :before-close="showClose">
                <el-table :data="dialogList" border style="width: 100%">
                    <el-table-column prop="level" label="类型" width="50">
                        <template slot-scope="{row}">
                            <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                                {{ row.level == 0 ? "拦截" : '预警' }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="data" label="内容" min-width="180">
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" type="primary" @click="showClose">确 定</el-button>
                </span>
            </el-dialog>
            <printPlan ref="printPlan"></printPlan>
            <el-dialog title="批量打印" :visible.sync="diaImgs" width="900px" :modal-append-to-body="true" :append-to-body="true">
                <el-button type="primary" v-print="'#imgs'" size="mini" style="margin-bottom:10px">打印</el-button>
                <div id="imgs" style="width: 800px;">
                    <div v-for="(key, index) in fileData" :key="index" style="height: 1100px;width: 800px; position: relative; ">
                        <el-image v-if="key.flag" :style="`width: 1100px;height: 800px;transform: rotateZ(90deg);position: absolute;left:-148px;bottom:148px;
`" :src="key.fileUrl" fit="contain"></el-image>
                        <el-image v-else :style="`width: 800px;height: 1100px; 
`" :src="key.fileUrl" fit="contain"></el-image>
                        <div style="page-break-after: always;"></div>
                    </div>
                </div>
            </el-dialog>
            <FileNewAction ref="FileNewAction" v-if="showFile" :showFile="showFile" @isshowFile="IsshowFile" @NewelectFileIds="changeInputModelgpy"></FileNewAction>
        </div>
        <ImageViewer v-if="showImgViewer" :url-list="imgPreviewUrl" :on-close="() => { showImgViewer = false }" :z-index="3000" />
        <DragUpload ref="dragUpload" title="文件上传" :multiple="true" :limit="100" @confirm="onUploadConfirm" />
        <!-- 扫描仪 -->
        <el-dialog title="扫描仪上传" destroy-on-close :visible.sync="scanShow" width="80%" append-to-body top="20px">
            <scannerPlugin v-if="scanShow" ref="scannerPlugin" @submit="scanOnSubmit"></scannerPlugin>
        </el-dialog>
    </div>
</template>

<script>
import print from 'vue-print-nb';
import NP from "number-precision";
import ImageViewer from 'element-ui/packages/image/src/image-viewer'
import { regionData } from 'element-china-area-data'
export default {
    name: "supplierFrom",
    components: { ImageViewer },
    props: ["actionData"],
    data() {
        //这里存放数据
        return {
            showImgViewer: false,
            imgPreviewUrl: [], // 当前要放大的图片存放位置
            mxHeight: 0,
            reviewNodeList: [], //审核任务
            taskData: {
                //审核数据
                auditState: 1,
                auditRemark: "",
                businessId: "",
            },
            options: regionData,
            selectedAddressIndex: 0, //地址选择
            selectedBankIndex: 0, //银行卡选择
            selectedFinanceIndex: 0, //财务选择
            selectedlicenceIndex: 0, //证照选择
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            isLoaded: false,
            showTabs: "",
            formDataList: [],
            sendDataInfoObj: {
                businessId: "",//对应的客户Id
                gchmType: 1,
                depName: "",
                depId: "",
                opmName: "",
                opmId: "",
                remark: "",
                applyReason: "",
            },
            sendDataInfo: {
                smBusterm: "",
                smFounddate: "",
                smHemcode: "",
                smIntype: "", //单位类型
                smIntypeName: "",
                smLegalperson: "", //法人
                smManrange: [], //经营范围
                smManrangeName: "",
                smName: "", //供应商名称
                smProrange: [], //生产范围
                smProrangeName: "",
                smWareaddress: "", //仓库地址
                smRegaddres: "", //注册地址
                smRegmoney: "", //注册资本
                smReserves1: "",
                smReserves2: "",
                smReserves3: "",
                smReserves4: "",
                smReserves5: "",
                smReserves6: "",
                smSocialcode: "",
                smTrerangeName: "",
                newLicencelinfos: [], //证照
                suplicencelinfos: [], //证照
                fileNumber: "", //档案编号
                sfiCreditperiod: 0,
                smBank: '',//开户行
                smBankaccount: '',//银行账户
                sfiCreditamount: 0,
                smQualityDirector: "",
                financialNumber: "",
                financialNumber: "",
                fileNumber: "",
                smProrangeValues: "",
                smManrangeValues: "",
                smRemark: "",
            },
            rangeObj: {
                p: [],
                m: [],
                t: [],
            }, //范围对象
            dictionariesDatas: [], //单位类型
            imgUrl: "", //图片显示根路径
            salesType: ["客户", "供应商", "收货", "", "提货"], //业务员类型
            type: 1,
            obj: {
                smManrangeValues: "", // 经营范围已选择范围名称
                smProrangeValues: "", // 诊疗分为已选择范围名称
            },
            smManrangeIds: [], // 经营范围已选择范围Id
            smProrangeIds: [], // 诊疗分为已选择范围Id
            smManrangeList: [], // 经营范围数据
            smProrangeList: [], // 诊疗分为数据
            rangeTitle: "",
            dialogRange: false,
            transferData: [], //穿梭框数据
            rangeValue: [],
            rangeNum: 0,
            tabForm: [],
            mxForm: [],
            footForm: [],
            DialogVisible: false,
            seId: "",
            seIndex: 0,
            seType: "",
            sField: "",
            seWidth: "",
            seTitle: "",
            parentSearchData: {},
            selectSalesIndex: 0,
            tableNum: false,
            dialogList: [],
            showDialog: false,
            showStatus: -1,
            message: "",//提示语
            diaImgs: false,
            fileData: [],
            print: {
                id: 'imgs',
                popTitle: 'erp', // 打印配置页上方的标题
                extraHead: 'erp', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
                preview: true, // 是否启动预览模式，默认是false
                previewTitle: 'erp', // 打印预览的标题
                previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
                zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
                previewBeforeOpenCallback() { console.log('正在加载预览窗口！'); console.log(that.msg, this) }, // 预览窗口打开之前的callback
                previewOpenCallback() { console.log('已经加载完预览窗口，预览打开了！') }, // 预览窗口打开时的callback
                beforeOpenCallback() { console.log('开始打印之前！') }, // 开始打印之前的callback
                openCallback() { console.log('执行打印了！') }, // 调用打印时的callback
                closeCallback() { console.log('关闭了打印工具！') }, // 关闭打印的callback(无法区分确认or取消)
                clickMounted() { console.log('点击v-print绑定的按钮了！') },
                standard: '',
                extarCss: '',
            },
            dataList: [],
            token: {
                token: sessionStorage.getItem("token"),
            },
            rulesList: [],
            zzList: [],
            fileList: [], //文件
            requesUrl: "",
            imgUrl: '',
            eventIndex: 0,
            showFile: false,
            LicensetypeList: [], //证照列表
            //---------扫描仪上传
            scanShow: false,
            printScanShow:false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    directives: {
        print
    },
    //监控data中的数据变化
    watch: {
        "sendDataInfo.smName": {
            //获取助记码
            handler: function (newValue, oldValue) {
                // this.sendDataInfo.smHemcode = this.$common.createPinyinCode(newValue,this.sendDataInfo.smHemcode);
                this.productVerify()

            },
            deep: true,
        },
        zzList: {
            deep: true,
            handler(nvl, ovl) {
                let arr = [...nvl]
                this.sendDataInfo.newLicencelinfos = this.sendDataInfo.newLicencelinfos.filter(item => {
                    if (nvl.includes(item.lityId)) {
                        arr.splice(arr.findIndex(items => items == item.lityId), 1)
                        return true
                    } else {
                        return false
                    }
                })
                this.sendDataInfo.newLicencelinfos.forEach((item, index) => {
                    if (item.uploadVoList.length > 0) {
                        item.uploadVoList.map(items => {
                            items.url = this.imgUrl + "/" + items.fileUrl
                            items.name = items.fileName
                            return items
                        })
                    } else {
                        item.uploadVoList = []
                    }
                })
                this.sendDataInfo.suplicencelinfos.forEach((item, index) => {
                    if (item.uploadVoList.length > 0) {
                        item.uploadVoList.map(items => {
                            items.url = this.imgUrl + "/" + items.fileUrl
                            items.name = items.fileName
                            return items
                        })
                    } else {
                        item.uploadVoList = []
                    }
                })
                this.$nextTick(() => {
                    arr.forEach(item => {
                        this.sendDataInfo.newLicencelinfos.push({
                            lityId: item, //证照类型
                            lityName: "",
                            isIntercept: 1, //是否拦截
                            sliCreater: 0,
                            sliRedate: 0,
                            sliReoffice: "",
                            sliReserves1: "",
                            sliReserves2: "",
                            sliReserves3: "",
                            sliReserves4: "",
                            sliReserves5: "",
                            sliReserves6: "",
                            sliTername: item, //证照名称
                            sliTernumber: "",// 证照号
                            sliTervalidity: 0,
                            smId: 0,
                            uploadVoList: [],
                            remark: "", //备注
                        })
                        var index = this.sendDataInfo.newLicencelinfos.length - 1
                        this.lityChange(item, index)
                    })
                })
            }
        },
        "sendDataInfo.newLicencelinfos": {
            handler: function (newValue, oldValue) {
                newValue.forEach(item => {
                    if (item.sliRedate && item.sliRedate != 0.5 && item.sliTervalidity && item.sliTervalidity != 0.5 && item.sliTervalidity < item.sliRedate) {
                        this.$message.error("有效期不能小于办证日期")
                        item.sliTervalidity = 0.5
                    }
                })
            },
            deep: true
        },

    },
    //方法集合
    methods: {
        showUploadDialog(index) {
            this.eventIndex = index
            this.$refs.dragUpload.open();
        },
        onUploadConfirm(files) {
            console.log('上传的文件:', files);
            files.forEach(item => {
                this.sendDataInfo.newLicencelinfos[this.eventIndex].uploadVoList.push({
                    fileUrl: item.fileUrl,
                    url: this.imgUrl + "/" + item.fileUrl,
                    fileName: item.fileName,
                    fileId: item.fileId,
                    fileType: this.sendDataInfo.newLicencelinfos[this.eventIndex].lityId,
                })
            })
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'smIntype') {
                this.dictionariesDatas.forEach(item => {
                    if (item.diValue == val) {
                        str = item.diName
                    }
                })
            } else if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        delRemove(index, key) {
            this.eventIndex = index
            this.sendDataInfo.newLicencelinfos[this.eventIndex].uploadVoList.splice(key, 1)
        },
        async fileUpload(files, length, index, e) {
            if (length - 1 >= index) {
                console.log(files[index]);
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                console.log(response);
                if (response.status == 200) {
                    this.sendDataInfo.newLicencelinfos[this.eventIndex].uploadVoList.push({
                        fileUrl: response.result[0].fileUrl,
                        url: this.imgUrl + "/" + response.result[0].fileUrl,
                        fileName: response.result[0].fileName,
                        fileId: response.result[0].fileId,
                        fileType: this.sendDataInfo.newLicencelinfos[this.eventIndex].lityId,
                    })
                    this.fileUpload(files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        changesliTervalidity(index) {

        },
        IsshowFile(value) {
            this.showFile = value
            console.log(this.showFile)
        },
        changeInputModelgpy(val) {
            this.sendDataInfo.newLicencelinfos[this.eventIndex].uploadVoList = [... this.sendDataInfo.newLicencelinfos[this.eventIndex].uploadVoList, ...val]
            this.showFile = false

        },
       //  打开文件上传组件
        openFile1(val) {
            if (val == 1) {
                this.scanShow = true
            } else {
                this.showFile = true
            }
        },
        // 扫描仪上传
        scanOnSubmit(val) {
            const currentLicence = this.sendDataInfo.newLicencelinfos[this.eventIndex]
            const fileType = currentLicence.lityId
            
            // 转换文件数据
            const list = val.map(item => ({
                fileUrl: item.fileUrl,
                url: `${this.imgUrl}/${item.fileUrl}`,
                fileName: item.fileName,
                fileId: item.fileId,
                fileType
            }))
            
            // 确保 uploadVoList 存在
            if (!currentLicence.uploadVoList) {
                currentLicence.uploadVoList = []
            }
            
            // 添加新文件
            currentLicence.uploadVoList = [...currentLicence.uploadVoList, ...list]
            this.scanShow = false
        },
        //查询所有证照类型
        getPartDictionariesData() {
            this.LicensetypeList = []
            this.$http
                .getPartDictionariesData({ ids: [41] })
                .then((res) => {
                    if (res && res.status == 200) {
                        res.result.DWZZLX.forEach((v) => {
                            // v.lityId = Number(v.diId)
                            v.lityId = v.diValue
                            this.LicensetypeList.push(v)
                        })
                        // console.log(this.LicensetypeList);
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "error",
                        message: "查询所有证照类型失败",
                    });
                });
        },
        judge(val) {
            if (this.diaImgs) {
                this.$nextTick(() => {
                    console.log(val, document.documentElement.querySelector(`.${val}`));
                })
            }
            // console.log(document.documentElement.querySelector(`.${val}`).querySelector('el-image__inner').clientHeight,
            // document.documentElement.querySelector(`.${val}`).querySelector('el-image__inner').clientWidth,);
            return true
        },
        confirmPrintImgs() {
            this.$print(document.getElementById('imgs'))
        },
        printImgs() {
            this.diaImgs = true
        },
        print() {
            this.$print(document.getElementById('prr'))
        },
        printImg(list) {
            let printArr = []
            list.forEach(item => {
                item.uploadVoList.forEach(e => {
                    if (e.fileUrl != '' && e.fileUrl) {
                        printArr.push(window.global_config.BASE_IMG_URL + '/' + e.fileUrl)
                    }
                })
            })
            this.fileData = []
            printArr.forEach(url => {
                let item = {
                    flag: "",
                    fileUrl: url
                }
                const img = new Image();
                img.src = url
                img.onload = () => {
                    console.log(img.src);
                    console.log(img.width);
                    console.log(img.height);
                    if (img.width > img.height) {
                        item.flag = true
                    } else {
                        item.flag = false
                    }
                    this.fileData.push(item)
                };

            })

            this.diaImgs = true
            //this.$common.batchPrintImage(printArr)
        },
        handleAddChange(value) {
            setTimeout(() => {
                var node = this.$refs['cascader'][0].getCheckedNodes()[0]
                if (!node) {
                    this.sendDataInfo.saiProvince = ""
                    this.sendDataInfo.saiCity = ""
                    this.sendDataInfo.saiArea = ""
                    return
                }
                if (node.pathLabels.length == 3) {
                    this.sendDataInfo.saiProvince = node.pathLabels[0]
                    this.sendDataInfo.saiCity = node.pathLabels[1]
                    this.sendDataInfo.saiArea = node.pathLabels[2]
                } else if (node.pathLabels.length == 2) {
                    this.sendDataInfo.saiProvince = node.pathLabels[0]
                    this.sendDataInfo.saiCity = node.pathLabels[1]
                }
            }, 100)
        },
        //客户验证
        productVerify() {
            var smName = this.sendDataInfo.smName.replace(/\s/g, "")
            if (smName != "") {
                this.verify()
            }
        },
        async verify() {
            const params = {
                "smId": 0,
                "smName": ""
            }
            for (const key in params) {
                if (this.sendDataInfo[key]) {
                    params[key] = this.sendDataInfo[key]
                } else {
                    params[key] = ""
                }
            }
            const responseData = await this.$http.gspSuppliercheckRepeatSup(params)
            if (responseData.status == 300) {
                this.message = responseData.message
            } else {
                this.message = ""
            }
        },
        tableRowClassName({
            row,
            rowIndex
        }) {
            return 'success-row';
        },
        //检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            if (type != 'smName') {
                this.parentSearchData[type] = this.sendDataInfo[type];
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item];
            });
        },
        changeInputModel(val) {
            console.log("返回", val);
            console.log("返回", this.seType);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == "smName") {
                    this.sendDataInfo['smName'] = val.smName
                    this.sendDataInfo['smId'] = val.smId
                    this.$emit("selectClick", val.smId)
                }
                this.paramValue(val);
            }
        },
        //判断为null或者空值时给初始值
        isNullOrUd(num) {
            if (typeof num === 'object' || isNaN(parseFloat(num))) {
                return true
            } else {
                return false
            }
        },
        // 下拉赋值
        handleChange(value, name) {
            // value默认参，name当前所需的name
            this.sendDataInfo[name] = value;
        },
        // 选择范围确定
        confirmRange() {
            if (this.rangeNum == 1) {
                this.smManrangeIds = this.rangeValue; //经营范围
                var value1 = [];
                this.smManrangeIds.forEach(val => {
                    if (this.smManrangeList.length > 0) {
                        if (this.smManrangeList.filter(item => item.discId == val).length > 0) {
                            value1.push(this.smManrangeList.filter(item => item.discId == val)[0].scopeName)
                        }
                    }
                })
                this.obj.smManrangeValues = value1.toString();
            } else if (this.rangeNum == 0) {
                this.smProrangeIds = this.rangeValue; //诊疗范围
                var value2 = [];
                this.smProrangeIds.forEach(val => {
                    if (this.smProrangeList.length > 0) {
                        if (this.smProrangeList.filter(item => item.discId == val).length > 0) {
                            value2.push(this.smProrangeList.filter(item => item.discId == val)[0].scopeName)
                        }
                    }
                })
                this.obj.smProrangeValues = value2.toString();
            }
            this.dialogRange = false;
        },
        // 过滤方法
        filterMethod(query, item) {
            if (query != '') {
                if (/^[a-zA-Z]*$/.test(query)) {
                    // alert("“" + str + "”里全是字母！");
                    return item.pinyin.indexOf(query) > -1;
                }
                else if (/^[\u4e00-\u9fa5]*$/.test(query)) {
                    // alert("“" + str + "”里全是汉字！");
                    return item.label.indexOf(query) > -1;
                }
            }
            return item.pinyin.indexOf(query) > -1;
        },
        dealMinWidth(field) {
            if (field == 'sliTervalidity' || field == 'sliReoffice' || field == 'sliRedate' || field == 'sliTernumber' || field == 'sliTername' || field == 'lityId') {
                return '200'
            } else if (field == 'uploadVoList') {
                return '230'
            } else {
                return '100'
            }
        },
        // 打开选择范围
        openRange(title, type) {
            this.rangeValue = [];
            this.transferData = [];
            this.rangeTitle = title;
            if (type == "smManrange") {
                this.rangeNum = 1;
                if (this.smManrangeIds.length > 0) {
                    this.rangeValue = this.smManrangeIds.map(Number);
                }
                this.smManrangeList.forEach((item) => {
                    this.transferData.push({
                        label: item.scopeName,
                        key: item.discId,
                        pinyin: item.scopeCode,
                    });
                });
            } else if (type == "smProrange") {
                this.rangeNum = 0;
                if (this.smProrangeIds.length > 0) {
                    this.rangeValue = this.smProrangeIds.map(Number);
                }
                this.smProrangeList.forEach((item) => {
                    this.transferData.push({
                        label: item.scopeName,
                        key: item.discId,
                        pinyin: item.scopeCode,
                    });
                });
            }
            this.dialogRange = true;
        },
        // 是否确认关闭
        handleClose(done) {
            this.$confirm("关闭弹窗将删除已选择的范围，确认关闭？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.dialogRange = false;
                })
                .catch(() => { });
        },
        //设置默认地址
        setDefaultAddress() {
            this.sendDataInfo.supaddresses.forEach((v) => (v.isDefault = 0));
            this.sendDataInfo.supaddresses[
                this.selectedAddressIndex
            ].isDefault = 1;
        },
        async showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                if (this.dataActionBox.actionType == 4) {
                    let responseData = await this.$http.getPenetrateData({ ids: [this.actionData.orderId] })
                    console.log(responseData);
                    if (responseData.status == 200) {
                        var res = responseData.result
                        // 选中的数据
                        this.$refs.printPlan.openDia(
                            this.actionData.orderId,
                            res.printSource,
                            res.jurId,
                            'oper'
                        );
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: 'error'
                        });
                    }
                } else {
                    // 选中的数据
                    this.$refs.printPlan.openDia(
                        this.actionData.orderId,
                        this.actionData.printSouce,
                        this.actionData.printJurId
                    );
                }
            } else {
                return;
            }
        },
        //业务员图片转换
        pictureFilePath(data) {
            console.log("img", data);
            var imgList = [];
            if (Array.isArray(data)) {
                data.forEach((item) => {
                    imgList.push(this.imgUrl + "/" + item.filePath);
                });
                return imgList;
            } else {
                // if(data.indexOf(',') > -1){
                var pathList = data.split(",");
                pathList.forEach((v) => {
                    imgList.push(this.imgUrl + "/" + v);
                });
                console.log("图片1", imgList);
                return imgList;
                // }else{
                //     console.log('图片2',imgList.push(this.imgUrl + '/' + data) )
                //    return imgList.push(this.imgUrl + '/' + data)
                // }
            }
        },
        //图片地址转换
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + "/" + item.fileUrl);
            });
            return imgList;
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        changesmIntype() {
            this.LicensetypeList.forEach(item => {
                this.$set(item, "isBT", 0)
                this.$set(item, "isKX", 0)
            })
            this.rulesList.forEach(item => {
                if (item['单位类型'] == this.sendDataInfo.smIntype) {
                    console.log(item['拦截证照']);

                    item['拦截证照'].forEach(items => {
                        var arr = items['证照名称'].split(",")
                        if (arr.length == 1) {
                            var flag = false
                            var flage = false
                            if (this.zzList.length > 0) {
                                this.zzList.forEach(item => {
                                    if (item == arr[0]) {
                                        flage = true
                                    }
                                })
                            }
                            if (!flage) {
                                this.zzList.push(arr[0])
                            }
                            this.LicensetypeList.forEach(item => {
                                if (item.diName == arr[0]) {
                                    this.$set(item, "isBT", 1)
                                }
                            })
                            if (this.sendDataInfo.newLicencelinfos.length > 0) {
                                this.sendDataInfo.newLicencelinfos.forEach(item => {
                                    if (item.lityId == arr[0]) {
                                        flag = true
                                    }
                                })
                            }
                            if (!flag) {
                                this.sendDataInfo.newLicencelinfos.push({
                                    lityId: arr[0], //证照类型
                                    lityName: "",
                                    isIntercept: 1, //是否拦截
                                    sliCreater: 0,
                                    sliRedate: 0,
                                    sliReoffice: "",
                                    sliReserves1: "",
                                    sliReserves2: "",
                                    sliReserves3: "",
                                    sliReserves4: "",
                                    sliReserves5: "",
                                    sliReserves6: "",
                                    sliTername: arr[0], //证照名称
                                    sliTernumber: "",// 证照号
                                    sliTervalidity: 0,
                                    smId: 0,
                                    uploadVoList: [],
                                    remark: "", //备注
                                })
                                var index = this.sendDataInfo.newLicencelinfos.length - 1
                                this.lityChange(arr[0], index)
                            }
                        } else {
                            this.LicensetypeList.forEach(item => {
                                arr.forEach(item1 => {
                                    if (item1 == item.diName) {
                                        this.$set(item, "isKX", 1)
                                    }
                                })
                            })

                        }

                    })
                }
            })
        },
        seeTypeChange() {
            this.LicensetypeList.forEach(item => {
                this.$set(item, "isBT", 0)
                this.$set(item, "isKX", 0)
            })
            this.rulesList.forEach(item => {
                if (item['单位类型'] == this.sendDataInfo.smIntype) {
                    item['拦截证照'].forEach(items => {
                        var arr = items['证照名称'].split(",")
                        if (arr.length == 1) {
                            this.LicensetypeList.forEach(item => {
                                if (item.diName == arr[0]) {
                                    this.$set(item, "isBT", 1)
                                }
                            })
                        } else {
                            this.LicensetypeList.forEach(item => {
                                arr.forEach(item1 => {
                                    if (item1 == item.diName) {
                                        this.$set(item, "isKX", 1)
                                    }
                                })
                            })

                        }
                    })
                }
            })
        },
        //证照选择变化
        lityChange(data, index) {
            if (/(营业)/g.test(data)) {
                this.sendDataInfo.newLicencelinfos[index].sliTernumber = this.sendDataInfo.smSocialcode
            } else {
                this.sendDataInfo.newLicencelinfos[index].sliTernumber = ''
            }
            this.sendDataInfo.newLicencelinfos[index].lityId = data;
        },
        blurChange(type) {
            if (type == 'smSocialcode') {
                this.sendDataInfo.newLicencelinfos.forEach((item, index) => {
                    if (item.sliTernumber == "" || item.sliTernumber == null) {
                        this.lityChange(item.lityId, index)
                    }
                })
            }
        },
        setzzList() {
            this.$http.getSupLicenceRule().then(res => {
                this.rulesList = JSON.parse(res.result)
            })
        },
        imgur() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        //保存
        async sendDataAction(formName) {
            this.$refs['dynamicValidateForm'].validate((valid1) => {
                if (valid1) {
                    this.$refs[formName].validate(async (valid) => {
                        if (valid) {
                            this.$refs['sendDataInfo1'].validate(async (valids) => {
                                if (valids) {
                                    this.sendDataInfo.newLicencelinfos.forEach(item => {
                                        if (item.sliTervalidity == 0) {
                                            item.sliTervalidity = ""
                                        }
                                        if (item.sliRedate == 0) {
                                            item.sliRedate = ""
                                        }
                                    })
                                    let interceptData = {
                                        formId: this.formDataList[1].jciId,
                                        suplicencelinfos: this.sendDataInfo.newLicencelinfos,
                                        smIntype: this.sendDataInfo.smIntype,
                                    };
                                    let addIntercept = await this.$http.checkVendorSupplier(interceptData);
                                    console.log(addIntercept);
                                    if (addIntercept.status == 200) {
                                        if (addIntercept.result.length > 0) {
                                            this.dialogList = addIntercept.result
                                            this.showStatus = this.dialogList.findIndex(item => item.level == 0)
                                            this.showDialog = true
                                        } else {
                                            this.sub()
                                        }
                                    } else {
                                        this.$message.error(addIntercept.message)
                                    }


                                } else {
                                    return this.$message({
                                        message: "请完善必填供应商信息",
                                        type: "error",
                                    });
                                }
                            });

                        } else {
                            return this.$message({
                                message: "请完善必填供应商信息",
                                type: "error",
                            });
                        }
                    });
                } else {
                    return this.$message({
                        message: "请完善必填申请信息",
                        type: "error",
                    });
                }
            })

        },
        showClose() {
            this.showDialog = false
            if (this.showStatus == -1) {
                this.sub()
            }
        },
        //保存
        async sub() {
            this.sendDataInfo.smManrange = this.smManrangeIds.toString();
            this.sendDataInfo.smProrange = this.smProrangeIds.toString();
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (sendData.areaCode == null || sendData.areaCode == "") {
                sendData.saiProvince = ""
                sendData.saiCity = ""
                sendData.saiArea = ""
            }
            sendData.newLicencelinfos.forEach(item => {
                if (item.uploadVoList.length > 0) {
                    item.uploadVoList.forEach(items => {
                        delete items.status
                        delete items.uid
                    })
                }
            })
            if (JSON.stringify(sendData.newLicencelinfos) == JSON.stringify(sendData.suplicencelinfos)) {
                delete sendData.newLicencelinfos
                delete sendData.suplicencelinfos
                sendData.suplicencelinfos = []
                sendData.newLicencelinfos = []
            }
            //else {
            //   sendData.suplicencelinfos.forEach(item => {
            //      sendData.newLicencelinfos.forEach(item1 => {
            //         for (const key in item) {
            //            for (const key1 in item1) {
            //               if (item[key] === ""&&(item1[key]==null||item1[key]=="")) {//老的
            //                  item1[key] = ""//新的
            //               } else if (item[key] === null&&(item1[key]==null||item1[key]=="")) {//老的
            //                  item1[key] = null//新的
            //               }
            //            }
            //         }
            //      })
            //   })
            //}
            let responseData;
            var params = {
                ...this.sendDataInfoObj,
                businessId: this.sendDataInfo.smId,
                desCibSuppliermaster: sendData,
            };
            if (this.dataActionBox.actionType == 0 || this.dataActionBox.actionType == 3) {
                responseData = await this.$http.gspChangeaddChangeSupp(params);
            } else {
                responseData = await this.$http.gspChangeupdateChangeInfo(params);
            }
            if (responseData.status == 200) {
                this.$emit("drawerCancel", true);
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 删除地址
        delSupplierAddress() {
            if (this.sendDataInfo.supaddresses.length < 1) {
                this.$message({
                    message: "当前没有地址信息",
                    type: "error",
                });
                return false;
            }
            this.$confirm("确定删除该数据?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.sendDataInfo.supaddresses.splice(
                        this.selectedAddressIndex,
                        1
                    );
                    this.selectedAddressIndex = 0;
                    // var delData = {
                    //     ids: [dataInfo.saiId],
                    // };
                    // let responseData = await this.$http.delSupplierAddress(delData);
                })
                .catch(() => { });
        },
        // 删除证照
        delCertofocates(row) {
            this.selectedlicenceIndex = this.sendDataInfo.newLicencelinfos.indexOf(row)
            if (this.sendDataInfo.newLicencelinfos.length < 1) {
                this.$message({
                    message: "当前没有证照信息",
                    type: "error",
                });
                return false;
            }
            this.$confirm("确定删除该数据?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.sendDataInfo.newLicencelinfos.splice(
                        this.selectedlicenceIndex,
                        1
                    );
                    this.selectedlicenceIndex = 0;
                    this.zzList = this.sendDataInfo.newLicencelinfos.map(item => {
                        return item.lityId
                    })
                })
                .catch(() => { });
        },
        //复制一行
        copyClick(row) {
            this.sendDataInfo.newLicencelinfos.push(JSON.parse(JSON.stringify(row)))
        },
        // 获取任务审核历史
        async getTaskReviewHistory(id) {
            let responseData = await this.$http.getTaskReviewHistory({
                ids: [id],
            });
            if (responseData.status == 200) {
                this.reviewNodeList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        //取消新增
        initActionBox() {
            this.$emit("drawerCancel");
        },

        //初始化
        init() {
            for (const key in this.sendDataInfo) {
                if (
                    key == "supaddresses" ||
                    key == "supbankinfos" ||
                    key == "newLicencelinfos" ||
                    key == "suplicencelinfos" ||
                    key == "smManrange"
                ) {
                    this.sendDataInfo[key] = [];
                } else if (key == "supfinancelinfos") {
                    for (const item in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][item] = "";
                    }
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            // console.log(this.sendDataInfo)
            this.dataActionBox.boxTitle = "";
        },
        isNull(value) {
            if (value != undefined && value != "") {
                return true;
            } else {
                return false;
            }
        },
        //父级传入 获取列表
        openBox() {
            this.printScanShow = window.global_config.printScanShow?true:false
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.filterMainField();
            this.init();
            this.dataActionBox.showStatus = true;
            if (this.dataActionBox.actionType == 0) {
            } else {
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in this.sendDataInfo) {
                    if (dataInfo[key] || dataInfo[key] === 0) {
                        this.$set(this.sendDataInfo, key, dataInfo[key])
                    }
                }
                this.$set(this.sendDataInfo, 'smId', dataInfo.smId)
                if (this.actionData.cate == 1) {
                    var dataInfo1 = JSON.parse(JSON.stringify(this.actionData.oldData1));
                    for (let key in this.sendDataInfoObj) {
                        if (dataInfo1[key] || dataInfo1[key] === 0) {
                            this.$set(this.sendDataInfoObj, key, dataInfo1[key])
                        }
                    }
                    this.$set(this.sendDataInfoObj, 'gchmId', dataInfo1.gchmId)
                }
                this.smManrangeIds = this.sendDataInfo.smManrange && this.isNull(this.sendDataInfo.smManrange) ? this.sendDataInfo.smManrange.split(",") : [];
                this.smProrangeIds = this.sendDataInfo.smProrange && this.isNull(this.sendDataInfo.smProrange) ? this.sendDataInfo.smProrange.split(",") : [];
                this.zzList = this.sendDataInfo.newLicencelinfos.map(item => item.lityId)
            }
            if (this.sendDataInfo.smIntype) {
                this.seeTypeChange()
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    this.mxHeight = this.$common.getBtnHeight()
                }, 16.7)
            });
        },
        //获取单位类型
        async getCateDictionariesDatas() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [16],
            });
            if (responseData.status == 200) {
                this.dictionariesDatas = responseData.result;
                console.log(this.dictionariesDatas);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取所有可用库房列表
        async getAllStorageRoom() {
            let responseData = await this.$http.getAllStorageRoom();
            if (responseData.status == 200) {
                this.storageRoomList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取生产/经营范围
        async getQueryScopeByType(type) {
            console.log(this.smManrangeIds);
            let ormId = sessionStorage.getItem("ormId");
            let params = {
                type: type,
                ormId: ormId,
            };
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByType(params);
            if (responseData.status == 200) {
                if (type == 1) {
                    this.smManrangeList = responseData.result;
                    if (this.dataActionBox.actionType != 0) {
                        var value1 = [];
                        if (this.smManrangeIds && this.smManrangeIds.length > 0) {
                            console.log(this.smManrangeIds, "ceshi");
                            console.log(this.smManrangeList, "ceshi");
                            this.smManrangeIds.forEach(val => {
                                if (this.smManrangeList.length > 0) {
                                    if (this.smManrangeList.filter(item => item.discId == val).length > 0) {
                                        value1.push(this.smManrangeList.filter(item => item.discId == val)[0].scopeName)
                                    }
                                }
                            })
                        }
                        this.obj.smManrangeValues = value1.toString();
                    }
                } else if (type == 0) {
                    this.smProrangeList = responseData.result;
                    if (this.dataActionBox.actionType != 0) {
                        var value2 = [];
                        if (this.smProrangeIds && this.smProrangeIds.length > 0) {
                            console.log(this.smProrangeIds, "ceshi1");
                            console.log(this.smProrangeList, "ceshi1");
                            this.smProrangeIds.forEach(val => {
                                if (this.smProrangeList.length > 0) {
                                    if (this.smProrangeList.filter(item => val == item.discId).length > 0) {
                                        value2.push(this.smProrangeList.filter(item => val == item.discId)[0].scopeName)
                                    }
                                }
                            })
                        }
                        this.obj.smProrangeValues = value2.toString();
                    }
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取状态
        getIsGsp(str, val) {
            try {
                if (str.indexOf("[") === -1) return val;
                str && str.replace(/\\/g, "");
                let arr = JSON.parse(str);
                let len = arr.length;
                let newStr = "";
                for (let i = 0; i < len; i++) {
                    if (arr[i].key == val) {
                        newStr = arr[i].value;
                        break;
                    }
                }
                return newStr ? newStr : val;
            } catch (ex) {
                return val;
            }
        },
        getRanges() {
            // //type 范围类型0.生产范围1.经营范围2.诊疗范围
            this.getQueryScopeByType(1);
            this.getQueryScopeByType(0);
        },
        // 过滤表单不同类型
        filterMainField() {
            this.dataList = []
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1 && key.jurconfigform[index].entityField != 'smProrange' && key.jurconfigform[index].entityField != 'smManrange') {
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                    } else if (key.jurconfigform[index].entityField == 'smProrange' || key.jurconfigform[index].entityField == 'smManrange') {
                        this.dataList.push(key.jurconfigform[index])
                    }
                }

            });
            var arr = [{ entityField: "newLicencelinfos" }, { entityField: "suplicencelinfos" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
        },
        // 获取申请人员信息
        initDep() {
            let info = JSON.parse(sessionStorage.getItem('userInfo'))
            this.sendDataInfoObj.depName = info.depName
            this.sendDataInfoObj.depId = info.depId
            this.sendDataInfoObj.opmName = info.opmName
            this.sendDataInfoObj.opmId = info.opmId
            this.sendDataInfoObj.gchmType = 1
        },
        openBoxS() {
            this.initDep()
            this.$nextTick(() => {
                this.openBox();
                this.setzzList()
                this.getRanges();
                this.isLoaded = true;
            });
            this.getCateDictionariesDatas(); //单位类型
            this.imgur()
            this.getPartDictionariesData()
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.openBoxS()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.baseForm .el-row {
    display: flex;
    flex-wrap: wrap;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    content: "";
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected .check {
    background-color: #409eff;
    border-color: #409eff;
}

.el-select-dropdown.is-multiple
    .el-select-dropdown__item.selected
    .check:after {
    transform: rotate(45deg) scaleY(1);
}

.el-select-dropdown.is-multiple .el-select-dropdown__item .check::after {
    box-sizing: content-box;
    content: "";
    border: 1px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    width: 3px;
    transition: transform 0.15s ease-in 0.05s;
    transform-origin: center;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item .check {
    display: inline-block;
    position: relative;
    top: 2px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    background-color: #fff;
    z-index: 1;
    transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
        background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}

/* 文本超长 */
::v-deep .el-select__tags-text {
    display: inline-block;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

::v-deep .el-select .el-tag__close.el-icon-close {
    top: -5px;
}

#smManrange,
#smProrange {
    width: 100%;
    display: flex;
    padding-left: 83px;
    margin-bottom: 10px;
}

::v-deep #smManrange .el-form-item__content,
::v-deep #smProrange .el-form-item__content {
    width: 100% !important;
}

::v-deep #smManrange .el-textarea__inner,
::v-deep #smProrange .el-textarea__inner {
    width: 76% !important;
    margin-right: 20px;
    font-size: 12px;
}

.cmTitle {
    color: #606266;
    font-size: 14px;
    padding-top: 4px;
}

.cmContent {
    padding-left: 10px;
    width: 90%;
}

.cmButton {
    margin-bottom: 6px;
}

::v-deep .el-transfer-panel {
    width: auto;
}

#csDia ::v-deep .el-dialog {
    min-width: 800px;
}

#smRegaddres,
#smWareaddress,
#smPlace,
#smRemark {
    width: 100% !important;
}

#smRegaddres ::v-deep .el-form-item__content,
#smWareaddress ::v-deep .el-form-item__content,
#smPlace ::v-deep .el-form-item__content,
#smRemark ::v-deep .el-form-item__content {
    width: 100% !important;
}

#smRegaddres ::v-deep .el-textarea__inner,
#smWareaddress ::v-deep .el-textarea__inner,
#smPlace ::v-deep .el-textarea__inner,
#smRemark ::v-deep .el-textarea__inner {
    width: 62% !important;
}

#smSocialcode ::v-deep .el-form-item__content,
#smName ::v-deep .el-form-item__content {
    width: 386px !important;
}

#smBankaccount ::v-deep .el-form-item__content {
    width: 386px !important;
}

::v-deep .el-image-viewer__close {
    color: #fff;
}

::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-textarea.is-disabled .el-textarea__inner {
    background-color: #fff;
    color: #333;
}

::v-deep
    .el-radio-button__orig-radio:disabled:checked
    + .el-radio-button__inner {
    background-color: #ccc;
}

::v-deep .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
    color: #333;
}

.baseForm ::v-deep .el-form-item__content {
    margin-left: 135px !important;
}

.baseForm ::v-deep .el-form-item__label {
    width: 135px !important;
}

.mxBox {
    margin: 10px;
    padding: 10px 0;
    margin-top: 0;
    padding-top: 0;
}

::v-deep .upload-demo ul {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
}

::v-deep .upload-demo img {
    width: 30px;
    height: 30px;
    margin-left: 0px;
}

::v-deep .upload-demo .el-upload-list--picture .el-upload-list__item {
    width: 86px;
    height: 42px;
    padding: 5px 0px;
    padding-left: 5px;
}

::v-deep .el-upload-list__item-name {
    margin-right: 0;
    font-size: 13px;
}

::v-deep .el-upload-list__item .el-icon-close {
    top: 2px;
    right: 2px;
}

::v-deep .el-upload-list--picture .el-upload-list__item-status-label {
    width: 40px;
    height: 24px;
    right: -20px;
    top: -9px;
}

::v-deep
    .el-upload-list--picture
    .el-upload-list__item.is-success
    .el-upload-list__item-name {
    line-height: 30px;
}

.el-table .success-row {
    background: #f0f9eb;
}

.xing {
    position: absolute;
    top: 0;
    left: 5px;
    font-size: 18px;
    font-weight: 800;
}

/* 图片上传样式 */
.uploadList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 220px;
    list-style: none;
}

.image {
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: 5px;
    margin-bottom: 5px;
    flex-shrink: 0;
    border: 1px solid #f3f3f3;
}

.image:nth-child(5n) {
    margin-right: 0;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.image:hover .del {
    display: inline-block;
}

.image_label {
    cursor: pointer;
    padding: 7px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}

::v-deep .el-image__error {
    font-size: 7px;
}
</style>